import {
  selectIsFetchingMonthDeclarations,
  selectIsSubmitingMonthDeclarations,
} from '@/domain/project-venue-month-declaration/project-venue-month-declarations.selectors';
import { useAppSelector } from '@/ui/hook/store';

export function useMonthDeclarationDisableSubmit() {
  const isSubmiting = useAppSelector(selectIsFetchingMonthDeclarations);
  const isFetching = useAppSelector(selectIsSubmitingMonthDeclarations);
  const disableSubmitActions = isSubmiting || isFetching;

  return { disableSubmitActions };
}
